module.exports = __webpack_public_path__ + "static/img-plexi-6e9e505ee9967b6cffcacbae060836fd.jpg";